/** SHA-256 em hex: o Mixpanel recebe só o hash, nunca o UUID do nosso banco. */
export const pseudonymize = async (value: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(value)
  )
  return Array.from(new Uint8Array(digest), byte =>
    byte.toString(16).padStart(2, '0')
  ).join('')
}
